import { render, staticRenderFns } from "./ChartSales.vue?vue&type=template&id=1f72cc52&"
import script from "./ChartSales.vue?vue&type=script&lang=js&"
export * from "./ChartSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f72cc52')) {
      api.createRecord('1f72cc52', component.options)
    } else {
      api.reload('1f72cc52', component.options)
    }
    module.hot.accept("./ChartSales.vue?vue&type=template&id=1f72cc52&", function () {
      api.rerender('1f72cc52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/ChartSales.vue"
export default component.exports